import EventEmitter from 'eventemitter3';
var eventCenter = new EventEmitter();
export { eventCenter };
export var SYNC_EVENT = 'recharts.syncMouseEvents';


//////////////////
// WEBPACK FOOTER
// ./~/recharts/es6/util/Events.js
// module id = ./node_modules/recharts/es6/util/Events.js
// module chunks = 1